import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import task01 from "./layouts/task-01/task";
import task02 from "./layouts/task-02/task";
import task03 from "./layouts/task-03/task";
import task04 from "./layouts/task-04/task";
import task05 from "./layouts/task-05/task";
import task06 from "./layouts/task-06/task";

const lesson: Lesson = {
  id: "48d6ab2c-b403-4c7d-b5d6-7ebcf667c28f",
  publicId: "17",

  name:
    "Sound Reduction Index for simple and composite structures (Reflection and transmission coefficient (impedances); transmission coefficient and sound reduction index for simple and composite structures)",

  difficulty: 3,
  contentTypes: { audio: false, interactive: true, video: false },
  body: [principle01, task01, task02, task03, task04, task05, task06],
};

export default lesson;
